import type { Entity } from '@/types/entity';

/**
 * 타입 안전 필드 접근자 (S4) — fields:Record<unknown> 위에서 number/axis를 안전하게 읽는다.
 * 파생층이 NaN·문자열축·누락을 일관되게 처리하도록(코드 리뷰 sub-1 P3 반영).
 */

export function readNumber(e: Entity, key: string): number | undefined {
  const v = e.fields[key];
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  if (typeof v === 'string' && v.trim() !== '') {
    const n = Number(v);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

/** 철학 축 신호(분석 0 ↔ 합일 1). 없으면 undefined, 있으면 0..1 clamp. */
export function readAxis(e: Entity): number | undefined {
  const n = readNumber(e, 'axis');
  return n === undefined ? undefined : Math.max(0, Math.min(1, n));
}
